/*
 * @Date: 2021-01-08 19:32:52
 * @LastEditTime: 2021-01-23 15:55:22
 */

import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const systemRouter: Array<RouteRecordRaw> = [
  {
    path: '/system',
    component: Layout,
    redirect: '/system/member',
    meta: {
      order: 6,
      title: 'system',
      icon: '#iconquanxian',
      roles: [
        'SYS_USER_R', 'SYS_USER_W',
        'SYS_ROLE_R', 'SYS_ROLE_W',
        'SYS_WORKFLOW_R', 'SYS_WORKFLOW_W'
      ]
    },
    children: [
      {
        path: 'member',
        component: () => import(/* webpackChunkName: "member" */ '@/views/system/Member.vue'),
        name: 'Member',
        meta: {
          title: 'member',
          icon: '#iconerjicaidan',
          roles: ['SYS_USER_R', 'SYS_USER_W'],
          keepAlive: true
        }
      },
      {
        path: 'role',
        component: () => import(/* webpackChunkName: "role" */ '@/views/system/Role.vue'),
        name: 'Role',
        meta: {
          title: 'role',
          icon: '#iconerjicaidan',
          roles: ['SYS_ROLE_R', 'SYS_ROLE_W'],
          keepAlive: true
        }
      },
      // {
      //   path: 'permission',
      //   component: () => import(/* webpackChunkName: "permission" */ '@/views/system/Permission.vue'),
      //   name: 'Permission',
      //   meta: {
      //     title: 'permission',
      //     icon: '#iconerjicaidan',
      //     roles: ['SYS_ROLE_R', 'SYS_ROLE_W']
      //   }
      // },
      {
        path: 'process',
        component: () => import(/* webpackChunkName: "member" */ '@/views/system/Process/ProcessPageList.vue'),
        name: 'ProcessPageList',
        meta: {
          title: 'process',
          icon: '#iconerjicaidan',
          roles: ['SYS_WORKFLOW_R', 'SYS_WORKFLOW_W'],
          keepAlive: true
        }
      },
      {
        path: 'processEdit/:id',
        component: () => import(/* webpackChunkName: "ApprovalFormDetail" */ '@/views/system/Process/ProcessUpdate.vue'),
        name: 'ProcessEdit',
        meta: {
          title: 'processEdit',
          hidden: true,
          noCache: true,
          roles: ['SYS_WORKFLOW_W']
        }
      }
    ]
  }
]
export default systemRouter
